import { auth } from "./firebase";

type AuthLike = {
  currentUser: { getIdToken: () => Promise<string> } | null;
  authStateReady?: () => Promise<void>;
};

export function makeAuthedFetch(deps: {
  fetch: typeof fetch;
  auth: AuthLike;
  baseUrl: string;
}) {
  const baseUrl = deps.baseUrl.replace(/\/$/, "");
  return async function authedFetch(path: string, init: RequestInit = {}): Promise<Response> {
    // Why: route loaders fire before Firebase finishes restoring persisted auth
    // state on page reload, leaving currentUser null and the request unauthed.
    // authStateReady resolves once persistence completes (cached after first call).
    if (deps.auth.authStateReady) await deps.auth.authStateReady();
    const headers = new Headers(init.headers);
    const user = deps.auth.currentUser;
    if (user) {
      const idToken = await user.getIdToken();
      headers.set("Authorization", `Bearer ${idToken}`);
    }
    return deps.fetch(`${baseUrl}${path}`, { ...init, headers });
  };
}

const API = (import.meta.env.VITE_API_URL ?? "/api") as string;

export const authedFetch = makeAuthedFetch({
  fetch: globalThis.fetch.bind(globalThis),
  auth,
  baseUrl: API,
});
